'use client';
import dynamic from 'next/dynamic';

import type { ReactNode } from 'react';

const AuthModal = dynamic(
  () => import('@shared/common/components/AuthModal').then((el) => el.AuthModal),
  {
    ssr: false,
  },
);

import BanxaModal from '@shared/common/components/modals/BanxaModal';
import ConnectAndSignModal from '@shared/common/components/modals/ConnectAndSignModal';
import CustomContentModal from '@shared/common/components/modals/CustomContentModal';
import SupportModal from '@shared/common/components/modals/SupportModal';

const GlobalModalsSwap = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {children}
      <AuthModal />
      <ConnectAndSignModal />
      <BanxaModal />
      <CustomContentModal />
      <SupportModal />
    </>
  );
};

export default GlobalModalsSwap;
